import React, { useState } from 'react';
import { LargeButton } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';

import resetImg from 'src/assets/reset.png';
import logoSvg from 'src/assets/logo_pride.svg';
import lockSvg from 'src/assets/lock.svg';
import eyeSvg from 'src/assets/eye.svg';
import eyeOffSvg from 'src/assets/eye-off.svg';
import {
  Container,
  FormContainer,
  ImageContainer,
  Input,
  Link,
  FooterText,
  LinkContainer,
  FooterContainer,
  FlexContainer,
  BackgroundImage,
  FormTitle,
  Logo,
  Text,
  FooterLink,
  LoginInput,
  LockIcon,
  EyeIcon,
} from './styles';

const PasswordReset: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<string>('password');
  const [isHidden, setIsHidden] = useState<string>('password');
  const [firstIcon, setFirstIcon] = useState<string>(eyeSvg);
  const [secIcon, setSecIcon] = useState<string>(eyeSvg);

  const handlePassword = (visible: string) => {
    setIsVisible(visible === 'password' ? 'text' : 'password');
    setFirstIcon(visible === 'password' ? eyeOffSvg : eyeSvg);
  };

  const handleConfirmPassword = (visible: string) => {
    setIsHidden(visible === 'password' ? 'text' : 'password');
    setSecIcon(visible === 'password' ? eyeOffSvg : eyeSvg);
  };

  return (
    <Container>
      <FormContainer>
        <FlexContainer>
          <Logo src={logoSvg} alt="Pride Global logo" />
          <FormTitle>{t('resetPassword.form.title')}</FormTitle>
          <LoginInput>
            <LockIcon src={lockSvg} />
            <Input type={isVisible} placeholder={t('resetPassword.form.password')} />
            <EyeIcon src={firstIcon} onClick={() => handlePassword(isVisible)} />
          </LoginInput>
          <LoginInput>
            <LockIcon src={lockSvg} />
            <Input type={isHidden} placeholder={t('resetPassword.form.confirmPassword')} />
            <EyeIcon src={secIcon} onClick={() => handleConfirmPassword(isHidden)} />
          </LoginInput>
          <LargeButton type="submit">{t('resetPassword.form.button')}</LargeButton>
          <Text>{t('resetPassword.signUp.text')}</Text>
          <Link href="/">{t('resetPassword.signUp.link')}</Link>
        </FlexContainer>
        <FooterContainer>
          <FooterText>{`PRIDE GLOBAL ${currentYear} ALL RIGHTS RESERVED`}</FooterText>
          <LinkContainer>
            <FooterLink href="https://prideglobal.com/terms-of-use/" target="_blank">
              {t('resetPassword.footer.termsOfUse')}
            </FooterLink>
            <FooterLink href="https://prideglobal.com/privacy-policy/" target="_blank">
              {t('resetPassword.footer.privacyPolicy')}
            </FooterLink>
            <FooterLink href="mailto:employeesupport@prideglobal.com" target="_blank">
              {t('resetPassword.footer.support')}
            </FooterLink>
          </LinkContainer>
        </FooterContainer>
      </FormContainer>
      <ImageContainer>
        <BackgroundImage src={resetImg} alt="Background image" />
      </ImageContainer>
    </Container>
  );
};

export default PasswordReset;
